import React from 'react';

import {Loading} from 'presentation/components/Loading/Loading';
import {ErrorState, SentinelLoading} from 'presentation/components';
import {GuideEmptyState} from 'presentation/modules/guide/shared/ui/components/GuideEmptyState';
import {translations} from 'presentation/translations-new';
import {Container, ContentCards} from './styles';
import {OdontoGuideCard} from 'presentation/modules/guide/odonto/ui/components/OdontoGuideCard';
import {Typography} from '@mui/material';

import {OdontoProvidersResultsProps} from '../../types';
import {useProvidersResults} from './hooks/useProvidersResults';

const {failToLoadTitle, failToLoadDescription, loading} = translations['pt-br'].commons;

export function ProvidersResults({
	isFetching,
	providersError,
	shouldRenderEmptyState,
	scrollableContentRef,
	loadingNewPageState,
	refetchProvidersQuery,
	providers,
	handleVisible,
}: OdontoProvidersResultsProps) {
	const {title} = useProvidersResults();

	if (isFetching) {
		return <Loading text={loading} minHeight="45%" />;
	}

	if (providersError) {
		return (
			<ErrorState
				title={failToLoadTitle}
				description={failToLoadDescription}
				handleRefresh={refetchProvidersQuery}
			/>
		);
	}

	if (shouldRenderEmptyState) {
		return <GuideEmptyState />;
	}

	return (
		<Container ref={scrollableContentRef}>
			<Typography variant="body2" color="text.secondary" fontWeight={600} mb={2}>
				{title}
			</Typography>
			<ContentCards>
				{providers?.map((item, index) => (
					<OdontoGuideCard provider={item} key={`${item.nome}-${String(index)}`} />
				))}
			</ContentCards>
			<SentinelLoading
				minHeight="200px"
				onVisible={handleVisible}
				isLoading={loadingNewPageState}
			/>
		</Container>
	);
}
